import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M19,9.41a.64.64,0,0,0-.56-.32H13.21a.65.65,0,0,0-.57.32L10,13.91a.7.7,0,0,0,0,.66l2.6,4.5a.65.65,0,0,0,.57.32H18.4a.64.64,0,0,0,.56-.32l2.6-4.5a.65.65,0,0,0,0-.66ZM18,18.09H13.58l-2.22-3.85,2.22-3.85H18l2.22,3.85Z' }),
  React.createElement('path', { d: 'M29.88,14C27,8.18,21.59,4.59,15.8,4.59S4.62,8.18,1.72,14a.66.66,0,0,0,0,.58c2.9,5.77,8.3,9.36,14.08,9.36S27,20.3,29.88,14.53A.6.6,0,0,0,29.88,14ZM15.8,22.59C10.61,22.59,5.74,19.4,3,14.24,5.74,9.08,10.61,5.89,15.8,5.89s10.06,3.19,12.77,8.35C25.86,19.4,21,22.59,15.8,22.59Z' }),
  React.createElement('path', { d: 'M21,26.19l.44,1.22a19.55,19.55,0,0,0,8-5.54l-1-.86A18.23,18.23,0,0,1,21,26.19Z' })
));